export default "__VITE_ASSET__CyDAHYte__"